module.exports = __webpack_public_path__ + "img/about-tab-1.b1d5657d.png";